import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isEmpty',
  standalone: false,
})
export class IsEmptyPipe implements PipeTransform {
  // eslint-disable-next-line class-methods-use-this
  transform(array: Array<any>): boolean {
    return array.length === 0;
  }
}
